import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@paypalcorp/pp-react'
import { NavLink } from 'react-router-dom'
import constant from '../../../../common/constant'
export const TopNavItem = forwardRef((props, ref) => {
  const { hasPath, children, className, ...rest } = props
  const classes = ['dev_dash__top-nav-item', className ? className : '']
    .join(' ')
    .trim()
  return (
    <Button
      as={hasPath ? NavLink : Button}
      className={classes}
      ref={ref}
      {...rest}
      data-dxa={constant.FPTI_PAGES_CATEGORIES.TOP_NAV + ',click,' + children}
    >
      {children}
    </Button>
  )
})

TopNavItem.displayName = 'TopNavItem'
TopNavItem.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
  hasPath: PropTypes.bool,
}
